import { render } from "./InstructorBlogs.vue?vue&type=template&id=3ebdb8a9"
import script from "./InstructorBlogs.vue?vue&type=script&lang=js"
export * from "./InstructorBlogs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__